import { cn } from "@lib/cn.ts";

const TONE: Record<string, string> = {
  GET: "text-get",
  POST: "text-post",
  PUT: "text-put",
  PATCH: "text-patch",
  DELETE: "text-delete",
};

interface Props {
  method: string;
  size?: "sm" | "md";
  className?: string;
}

export function MethodChip({ method, size = "sm", className }: Props) {
  const upper = method.toUpperCase();
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-sm2 border font-mono font-semibold uppercase tracking-wider",
        "border-current/25 bg-current/8",
        size === "sm" ? "px-1.5 py-px text-[10px]" : "px-2 py-0.5 text-[11px]",
        TONE[upper] ?? "text-muted",
        className,
      )}
    >
      {upper}
    </span>
  );
}
